"use client";

import { ASSET_PREFIX } from "@/config";
import LazyContactForm from "./LazyContactForm";

import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Autoplay,
  A11y,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BANNERS = [
  
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026.webp`,
    alt: "4 BHK Villas for sale in Coimbatore",
  },
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer-2.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026-2.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026-2.webp`,
    alt: "Premium 4 BHK Villas in Coimbatore",
  },
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer-3.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026-3.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026-3.webp`,
    alt: "Luxury Villas for sale in Coimbatore",
  },
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer-4.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026-4.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026-4.webp`,
    alt: "Premium Villa Community in Coimbatore",
  },
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer-5.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026-5.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026-5.webp`,
    alt: "Luxury 4 BHK Villas in Coimbatore",
  },
  {
    desktop: `${ASSET_PREFIX}/images/plus-willa-website-banner-live-closer-6.webp`,
    laptop: `${ASSET_PREFIX}/images/pluswilla-laptop-banner-2026-6.webp`,
    mobile: `${ASSET_PREFIX}/images/pluswilla-mobile-banner-2026-6.webp`,
    alt: "Premium Villa Community in Coimbatore",
  },
  
];

export default function BannerImage() {
  return (
    <>
      <section
        aria-label="Plus Willa property banners"
        className="relative w-full overflow-hidden bg-[#000] aspect-[1080/1350] min-[651px]:aspect-[1480/1080] min-[1480px]:aspect-[2320/1080] min-[1480px]:min-h-[820px]"
      >
        {/* ======================================================
            BANNER SLIDER
        ====================================================== */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay, A11y]}
          slidesPerView={1}
          slidesPerGroup={1}
          speed={900}
          loop={true}
          grabCursor={true}
          watchSlidesProgress={true}

          /*
            Autoplay:
            1 → 2 → 3 → 4 → 5 → 1
          */
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: false,
            waitForTransition: true,
          }}

          /*
            Custom navigation buttons
          */
          navigation={{
            prevEl: ".banner-prev",
            nextEl: ".banner-next",
          }}

          /*
            Pagination
          */
          pagination={{
            el: ".banner-pagination",
            clickable: true,
            bulletClass: "banner-bullet",
            bulletActiveClass: "banner-bullet-active",
          }}

          /*
            Accessibility
          */
          a11y={{
            enabled: true,
            prevSlideMessage: "Previous banner",
            nextSlideMessage: "Next banner",
            paginationBulletMessage: "Go to banner {{index}}",
          }}
          className="h-full w-full"
        >
          {BANNERS.map((banner, index) => (
            <SwiperSlide
              key={banner.desktop}
              className="h-full w-full"
            >
              <picture className="block h-full w-full">
                {/* Mobile */}
                <source
                  media="(max-width: 650px)"
                  srcSet={banner.mobile}
                />

                {/* Laptop / Tablet */}
                <source
                  media="(max-width: 1479px)"
                  srcSet={banner.laptop}
                />

                {/* Desktop */}
                <img
                  src={banner.desktop}
                  alt={banner.alt}
                  width={1920}
                  height={900}
                  loading={index === 0 ? "eager" : "lazy"}
                  fetchPriority={index === 0 ? "high" : "auto"}
                  decoding="async"
                  className="block h-full w-full object-cover object-center min-[1480px]:object-center"
                />
              </picture>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* ======================================================
            DARK GRADIENT OVERLAY
        ====================================================== */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 z-[2] bg-gradient-to-t from-black/20 via-transparent to-transparent"
        />

        {/* ======================================================
            LEFT NAVIGATION
            VERTICALLY CENTERED
        ====================================================== */}
        <button
  type="button"
  aria-label="Previous banner"
  className="banner-prev cursor-pointer absolute left-[15px] sm:left-[25px] lg:left-[35px] top-1/2 z-[40] flex h-[44px] w-[44px] -translate-y-1/2 items-center justify-center rounded-full border border-white/70 bg-black/25 text-white backdrop-blur-[5px] transition-all duration-300 hover:border-white hover:bg-white hover:text-black sm:h-[50px] sm:w-[50px]"
>
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* ======================================================
            RIGHT NAVIGATION
            VERTICALLY CENTERED
        ====================================================== */}
        <button
  type="button"
  aria-label="Next banner"
  className="banner-next cursor-pointer absolute right-[15px] sm:right-[25px] lg:right-[35px] top-1/2 z-[40] flex h-[44px] w-[44px] -translate-y-1/2 items-center justify-center rounded-full border border-white/70 bg-black/25 text-white backdrop-blur-[5px] transition-all duration-300 hover:border-white hover:bg-white hover:text-black sm:h-[50px] sm:w-[50px]"
>
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M9 6L15 12L9 18"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* ======================================================
            PAGINATION - BOTTOM CENTER
        ====================================================== */}
        <div className="absolute bottom-[25px] left-1/2 z-[40] -translate-x-1/2 sm:bottom-[35px]">
          <div className="banner-pagination flex !w-auto items-center justify-center gap-[8px]" />
        </div>

        {/* ======================================================
            EXISTING BOTTOM CONTENT
        ====================================================== */}
        <div className="pointer-events-none absolute bottom-0 left-[4.5%] z-[10] flex w-[90.5%] flex-col items-start justify-between gap-0 p-0 pb-[70px] text-white sm:p-5 sm:pb-[85px] md:flex-row md:items-end md:gap-[50px]">
          <div className="hidden w-full gap-[8px] md:grid sm:w-[165px] 2xl:w-[250px]" />
        </div>
          {/* contact form */}
        <div className="lg:absolute right-[5%] top-1/2 -translate-y-1/2 z-[55] rounded-[10px] bg-[#f5f5f5] p-6 pb-6 hidden min-[1200px]:block">
          <p className="mb-[8px] text-left text-[20px] font-[500] tracking-[-0.03em]">
            To Book a Site Visit!
          </p>

          <LazyContactForm eager />
        </div>
      </section>

      {/* ======================================================
          CUSTOM SWIPER CSS
      ====================================================== */}
      <style jsx global>{`
        .banner-pagination {
          position: relative !important;
          left: auto !important;
          right: auto !important;
          top: auto !important;
          bottom: auto !important;

          display: flex !important;
          align-items: center !important;
          justify-content: center !important;

          width: auto !important;
        }

        .banner-bullet {
          box-sizing: border-box;
          display: block;

          width: 24px;
          height: 24px;

          padding: 8px;
          margin: 0 !important;

          border: 0;
          border-radius: 999px;

          background: rgba(255, 255, 255, 0.55);
          background-clip: content-box;

          opacity: 1;

          cursor: pointer;

          transition:
            width 0.3s ease,
            background-color 0.3s ease,
            transform 0.3s ease;
        }

        .banner-bullet:hover {
          background: rgba(255, 255, 255, 0.9);
        }

        .banner-bullet-active {
          width: 44px;
          background: #ffffff;
        }

        /* Remove Swiper default arrows */
        .banner-prev::after,
        .banner-next::after {
          display: none !important;
          content: none !important;
        }

        /*
          Because loop=true,
          buttons should never visually appear disabled.
        */
        .banner-prev.swiper-button-disabled,
        .banner-next.swiper-button-disabled {
          opacity: 1 !important;
          cursor: pointer !important;
          pointer-events: auto !important;
        }

        @media (max-width: 650px) {
          .banner-bullet {
            width: 24px;
            height: 24px;
          }

          .banner-bullet-active {
            width: 38px;
          }
        }
      `}</style>
    </>
  );
}